import { isEmpty } from 'lodash';

import { removeQuotes } from '@app/utils';

import { createBooleanChipQuery } from './parseMaskedAdvancedSearchQuery';
import { getCqlFieldQualifierValue } from './getCqlFieldQualifierValue';
import { getMaskedQuery } from './getMaskedQuery';
import { FormValues } from '../constants';

const createAdvancedSearchQuery = (
  searchRows: FormValues,
  getQuery: typeof getMaskedQuery
): string =>
  Object.values(searchRows).reduce((queryString, row) => {
    const shouldPrependChip = !isEmpty(queryString) && Boolean(row.booleanChip);
    const chip = shouldPrependChip
      ? createBooleanChipQuery(row.booleanChip)
      : '';

    const currentRowString = row.value
      ? `${chip}${getQuery({
          field: row.field,
          qualifier: row.qualifier,
          value: removeQuotes(row.value),
        })}`
      : '';

    return `${queryString}${currentRowString}`;
  }, '');

export const createMaskedAdvancedSearchQuery = (searchRows: FormValues) =>
  createAdvancedSearchQuery(searchRows, getMaskedQuery);

export const createCqlAdvancedSearchQuery = (searchRows: FormValues) =>
  createAdvancedSearchQuery(searchRows, getCqlFieldQualifierValue);
